/**
 * Created by mgoria on 11/09/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateCognitoDatasetException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when open or create a CognitoSync dataset
 */
let CreateCognitoDatasetException = exports.CreateCognitoDatasetException = function (_Exception) {
  _inherits(CreateCognitoDatasetException, _Exception);

  /**
   * @param {String} dataset
   * @param {Object} error
   */
  function CreateCognitoDatasetException(dataset, error) {
    _classCallCheck(this, CreateCognitoDatasetException);

    return _possibleConstructorReturn(this, (CreateCognitoDatasetException.__proto__ || Object.getPrototypeOf(CreateCognitoDatasetException)).call(this, `Error on opening or creating "${dataset}" Cognito dataset. ${error}`));
  }

  return CreateCognitoDatasetException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/CreateCognitoDatasetException.js
// module id = 435
// module chunks = 0